export default [
  [
    {
      title: "购物指南",
      level: 1,
      location: {
        pathname: "/help",
        search: `categoryId=2`,
      },
    },
    {
      title: "购物流程",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=2&articleId=33`,
      },
    },
    {
      title: "交易条款",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=2&articleId=22`,
      },
    },
    {
      title: "用户协议",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=2&articleId=23`,
      },
    },
  ],
  [
    {
      title: "配送方式",
      level: 1,
      location: {
        pathname: "/help",
        search: `categoryId=3`,
      },
    },
    {
      title: "上门自提",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=3&articleId=26`,
      },
    },
    {
      title: "发货与签收规范",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=3&articleId=25`,
      },
    },
    {
      title: "第三方配送服务说明",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=3&articleId=24`,
      },
    },
  ],
  [
    {
      title: "支付方式",
      level: 1,
      location: {
        pathname: "/help",
        search: `categoryId=4`,
      },
    },
    {
      title: "货到付款",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=4&articleId=27`,
      },
    },
    {
      title: "在线支付",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=4&articleId=28`,
      },
    },
    {
      title: "支付错误",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=4&articleId=29`,
      },
    },
  ],
  [
    {
      title: "售后服务",
      level: 1,
      location: {
        pathname: "/help",
        search: `categoryId=5`,
      },
    },
    {
      title: "服务承诺",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=5&articleId=30`,
      },
    },
    {
      title: "退款说明",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=5&articleId=32`,
      },
    },
    {
      title: "服务总则",
      level: 2,
      location: {
        pathname: "/help",
        search: `categoryId=5&articleId=31`,
      },
    },
  ],
  [
    {
      title: "会员中心",
      level: 1,
    },
    {
      title: "浏览记录",
      level: 2,
    },
    {
      title: "我的收藏",
      level: 2,
    },
    {
      title: "帮助中心",
      level: 2,
      location: {
        pathname: "/help",
      },
    },
  ],
];
